import React from "react";
import { Container, Card, CardBody, Button, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { authenticationAction } from "../../_actions";
import i18next from "i18next";

import { CzechFlag, USAFlag } from "../SidePanel";
import { SuccessIcon } from '.';

const PaymentSuccess = ({logout}:any) => {
const { t } = useTranslation('guest');

const changeLanguage = (lang: any) => {
i18next.changeLanguage(lang);
}


return (
<Container>
  <Row style={{marginTop: "100px"}} className="justify-content-center">
    <Col md="8" className="d-flex flex-column">
    <Card className="w-100">
      <CardBody className="text-center d-flex flex-column">
        <div className="d-flex align-self-center" style={{width:"150px"}}>
          <SuccessIcon />
        </div>
        <h1>{t("payment_success")}</h1>
        <p>{t("thank_you_your_payment_was_successfully_completed")}</p>
        <Row style={{ justifyContent: "center", padding: "30px 0" }}>
          <Col style={{ textAlign: "center" }} sm="12" md="4">
          <Link to={`login`} onClick={()=> logout()}>
          <Button className="w-100 sypal-background">
            {t("back")}
          </Button>
          </Link>
          </Col>
        </Row>
      </CardBody>
    </Card>

    <Row className="justify-content-center pt-4">
      <Col md="4">
      <Row>
        <Col className="text-center" onClick={()=> changeLanguage("cs")}>
        <i className="p-0 m-auto">
          <CzechFlag />
        </i>
        </Col>
        <Col className="text-center" onClick={()=> changeLanguage("en")}>
        <i className="p-0 m-auto">
          <USAFlag />
        </i>
        </Col>
      </Row>
      </Col>
    </Row>


    </Col>
  </Row>
</Container>
);
};


const mapDispatchToProps = (dispatch:any) => {
return bindActionCreators({
logout: authenticationAction.logout,
}, dispatch)
};

const PaymentSuccessComponent = connect(null, mapDispatchToProps)(PaymentSuccess);

export { PaymentSuccessComponent as PaymentSuccess };